module.exports = __webpack_public_path__ + "img/recruit.7f51d51c.jpeg";